<template>
  <modal-dialog v-if="visible" @close="onClose" class="whiteboard-modal" :hide-close="false">
    <h3>Quadro branco</h3>
    <whiteboard-toolbar :mode="mode"
        :stroke-color="strokeColor"
        :fill-color="fillColor"
        :bg-color="bgColor"
        @set-mode="setMode"
        @undo="undo"
        @redo="redo"
        @clear="clear"
        @update-sides="(sides) => polygonSides = sides"
        @update-stroke-color="(color) => strokeColor = color"
        @update-fill-color="(color) => fillColor = color"
        @update-bg-color="(color) => bgColor = color"
    />

    <div class="canvas-wrapper">
       <whiteboard-canvas ref="canvas"
          :initialDataUrl="initialDataUrl"
          :polygonSides="polygonSides"
          :strokeColor="strokeColor"
          :fillColor="fillColor"
          :bgColor="bgColor"
       />
    </div>

    <div class="col-xs-12 text-right m-t-md modal-btns">
      <button class="btn btn-default close-btn" @click="onClose">Cancelar</button>
      <button class="btn btn-primary save-btn" @click="onSave">Salvar</button>
    </div>
  </modal-dialog>
</template>

<script>
import ModalDialog from '../base/Modal.vue';
import WhiteboardToolbar from '../sections/WhiteboardToolbar.vue';
import WhiteboardCanvas from './WhiteboardCanvas.vue';

export default {
  name: 'WhiteboardModal',
  components: { ModalDialog, WhiteboardToolbar, WhiteboardCanvas },
  props: { visible: { type: Boolean, default: false }, initialDataUrl: { type: String, default: null } },
  data() {
    return {
      mode: 'draw',
      polygonSides: 3,
      strokeColor: '#000000',
      fillColor: 'transparent',
      bgColor: '#ffffff'
    };
  },
  methods: {
    setMode(m) { this.mode = m; this.$refs.canvas.setMode && this.$refs.canvas.setMode(m); },
    undo() { this.$refs.canvas.undo && this.$refs.canvas.undo(); },
    redo() { this.$refs.canvas.redo && this.$refs.canvas.redo(); },
    clear() { if(confirm('Limpar quadro?')) this.$refs.canvas.clear(); },
    onSave() { const dataURL = this.$refs.canvas.toDataURL(); this.$emit('save', dataURL); },
    onClose() { this.$emit('close'); }
  }
}
</script>

<style scoped>
.whiteboard-modal :deep(.modal-container) {
  width: 95%;
  max-width: 950px;
  margin: 10px auto;
  padding: 15px;
}

.canvas-wrapper {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 10px;
  background-color: #ffffff;
}

.modal-btns {
  display: flex;
  justify-content: space-between;
}

@media (max-width: 767px) {
  .whiteboard-modal :deep(.modal-container) {
    width: 98%;
    padding: 10px;
  }

  .modal-btns .btn {
    width: 48%;
    display: inline-block;
  }
}
</style>
